import { render } from "./storelist.vue?vue&type=template&id=45bc2fcd&scoped=true"
import script from "./storelist.vue?vue&type=script&lang=js"
export * from "./storelist.vue?vue&type=script&lang=js"

import "./storelist.vue?vue&type=style&index=0&id=45bc2fcd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bc2fcd"]])

export default __exports__